'use client';

import { ReactNode } from 'react';
import { usePathname } from 'next/navigation';
import { NextIntlClientProvider } from "next-intl";
import { SessionProvider } from "next-auth/react";
import { CartProvider } from "@/components/cart";
import TopNav from "@/components/header/topNav";
import ScrollToTopButton from '@/components/home-page/TopButton';
import Footer from '@/components/footer/footer';
import End from '@/components/footer/end';
import Letstalk from '@/components/header/LetsTalkFix';

interface ClientLayoutProps {
  locale: string;
  messages: any;
  children: ReactNode;
}

export default function ClientLayout({ locale, messages, children }: ClientLayoutProps) {
  const pathname = usePathname();
  const isHomePage = pathname === `/${locale}` || pathname === `/${locale}/`;

  return (
    <NextIntlClientProvider locale={locale} messages={messages} timeZone="UTC">
      <SessionProvider basePath="/api/auth">
        <CartProvider>
         <Letstalk/>
          {children}
         
        
        </CartProvider>
      </SessionProvider>
    </NextIntlClientProvider>
  );
}